import { render, staticRenderFns } from "./confirm-new-customer-email.vue?vue&type=template&id=4cb52728&scoped=true&"
import script from "./confirm-new-customer-email.vue?vue&type=script&lang=js&"
export * from "./confirm-new-customer-email.vue?vue&type=script&lang=js&"
import style0 from "./confirm-new-customer-email.vue?vue&type=style&index=0&id=4cb52728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb52728",
  null
  
)

export default component.exports